import { Skeleton, Stack } from '@mui/material';

export function SkillsSkeleton() {
  return (
    <Stack spacing={1}>
      <Skeleton variant="rectangular" width="100%" height={25} sx={{ borderRadius: '4px' }} />
      <Skeleton variant="rectangular" width="100%" height={25} sx={{ borderRadius: '4px' }} />
      <Skeleton variant="rectangular" width="100%" height={25} sx={{ borderRadius: '4px' }} />
    </Stack>
  );
}
